var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, luxColors, useInterval, util } from '@alucio/lux-ui';
import { MODE_TYPE, useLocalAudioToggle, useLocalVideoToggle, useRoomState, useVideoContext } from '../../main';
import MeetingControls, { PresentationMenuOptionsEnum } from './MeetingControls/MeetingControls';
import RightSidePanel from './RightSideBar/RightSideBar';
import DialInModal from './DialInModal/DialInModal';
import { ATTENDEE_STATUS } from '@alucio/aws-beacon-amplify/src/API';
import { virtualUpdateCallStats, } from '@alucio/aws-beacon-amplify/src/graphql/mutations';
import { Logger as TWLogger } from 'twilio-video';
import VideoContainer from './Video/VideoContainer';
import { API, graphqlOperation, Logger } from 'aws-amplify';
import { PresentationContainer } from '../DNA/DNAPresentationContainer/DNAPresentationContainer';
import { RecordingStatus } from '../../hooks/useIsRecording';
import { withAVChecker } from './Video/WithVideoChecker';
import { AttendeeShareScreenProvider, useScreenShareToggle, useScreenShareParticipant, ScreenShareToggleProvider, } from '@alucio/video';
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors';
import { MeetingControlsContext } from '../../../src/hooks/useMeetingControls/useMeetingControl';
import LeftSidePanel from './LeftSideBar/LeftSideBar';
const logger = new Logger('VIRTUAL', 'INFO');
const twLogger = TWLogger.getLogger('twilio-video');
const MAX_ATTENDEES = 19;
// [TODO-781] : There's a heartbeat causing everything to rerender every couple of seconds
// It should not re-render if nothing happens ...
const styles = StyleSheet.create({
    container: {
        flex: 10,
    },
    contentContainer: {
        width: '100%',
        zIndex: -1,
    },
    fullScreenHeaderWrapper: {
        position: 'absolute',
        width: '100%',
        bottom: 0,
    },
    header: {
        height: 60,
    },
    meetingControlsContainer: {
        zIndex: 1,
    },
    mainContainer: {
        backgroundColor: luxColors.virtual.background,
        overflow: 'hidden',
    },
    presentationWrapper: {
        alignSelf: 'center',
        flex: 1,
        marginTop: 16,
        marginBottom: 20,
        maxWidth: 1300,
        minWidth: 900,
        paddingLeft: 20,
        paddingRight: 20,
        width: '100%',
    },
    sideBarStyle: {
        flexDirection: 'row',
        width: '100%',
    },
});
function Layout(props) {
    var _a;
    const { audioFiles, attendeesPerPage, background, currentAttendees, deviceSettings, dialInNumbers, hostName, meetingURL, displayContentPanel, recImage, hideContentPanel, isHostPresenting, leftSide, mode, myContentPanel, onAcceptCall, onAttendeeConnected, onAttendeeDisconnected, onConnected, onDenyCall, onError, onLeaving, onRemoveFromCall, onStopPresenting, setIsScreenSharing, presentation, presentationMode, rightSide, showContentPanel, toggleHostNotes, virtual, searchPanel, visibleSearch, setVisibleSearch, } = props;
    const { connect, room, isConnecting, localTracks, getLocalDataTrack, } = useVideoContext();
    const [localPhoneAudio, setLocalPhoneAudio] = useState(false);
    const [dialInModalVisible, setDialInModalVisible] = useState(false);
    const roomState = useRoomState();
    const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
    const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
    const [isInitialState, setInitialState] = useState(true);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isSharing, toggleScreenShare] = useScreenShareToggle();
    const [disabledOptions, setDisabledOptions] = useState([
        PresentationMenuOptionsEnum.SHARE_SCREEN,
        PresentationMenuOptionsEnum.RECORD,
        PresentationMenuOptionsEnum.MY_CONTENT,
    ]);
    const screenShareParticipant = useScreenShareParticipant();
    const selectedPresentationOptions = selectedMenuItems();
    const [hasConnected, setHasConnected] = useState(false);
    const isOtherUserScreenSharing = screenShareParticipant && !isSharing;
    // We use a ref intead of state to allow handleDisconnect (which is bound to a twilio event) to be able to read
    // the latest value
    const isLeavingRef = React.useRef(false);
    useEffect(() => {
        if (!isOtherUserScreenSharing && !isHostPresenting) {
            setIsFullScreen(false);
        }
    }, [isOtherUserScreenSharing, isHostPresenting]);
    useEffect(() => {
        setIsScreenSharing === null || setIsScreenSharing === void 0 ? void 0 : setIsScreenSharing(isSharing);
    }, [isSharing]);
    useEffect(() => {
        if (mode === MODE_TYPE.HOST && !isInitialState) {
            if (isSharing) {
                analytics === null || analytics === void 0 ? void 0 : analytics.track('VIRTUAL_SCREEN_SHARE', {
                    action: 'SCREEN_SHARE',
                    category: 'VIRTUAL',
                    sessionId: virtual.session.id,
                });
            }
            else {
                analytics === null || analytics === void 0 ? void 0 : analytics.track('VIRTUAL_STOP_SCREEN_SHARE', {
                    action: 'STOP_SCREEN_SHARE',
                    category: 'VIRTUAL',
                    sessionId: virtual.session.id,
                });
            }
        }
    }, [isSharing]);
    useEffect(() => {
        isInitialState && isHostPresenting && (setInitialState(false));
        isInitialState && screenShareParticipant && (setInitialState(false));
    }, [isHostPresenting, screenShareParticipant]);
    // [TODO] - Check
    // In attendee mode the user already selected if video/audio is enabled
    useEffect(() => {
        if (deviceSettings) {
            if (deviceSettings.isVideoEnabled !== isVideoEnabled) {
                toggleVideoEnabled();
            }
            if (isAudioEnabled && (!deviceSettings.isAudioEnabled || deviceSettings.isPhoneAudio)) {
                toggleAudioEnabled(false);
            }
        }
    }, []);
    useEffect(() => {
        screenShareParticipant && setInitialState(false);
    }, [screenShareParticipant]);
    useEffect(() => {
        function init() {
            return __awaiter(this, void 0, void 0, function* () {
                logger.debug('Entered init function');
                if (virtual && virtual.joinToken && roomState === 'disconnected' && !isConnecting) {
                    logger.debug('Attempting connection');
                    // Instantiate the data track. Must be called before the connect.
                    getLocalDataTrack();
                    twLogger.setLevel('info');
                    if (yield connect(virtual.joinToken, { tracks: localTracks })) {
                        setHasConnected(true);
                        logger.debug('Twilio Connect successful');
                        onConnected && onConnected();
                        setDisabledOptions([]);
                        if (deviceSettings && deviceSettings.isPhoneAudio) {
                            // Need to show dialog /w dial in info
                            setDialInModalVisible(true);
                        }
                    }
                    else {
                        onError && onError('Unable to start meeting. Please refresh the page and try again.', true);
                    }
                }
            });
        }
        if (!hasConnected) {
            init();
        }
        else {
            if (roomState === 'disconnected' && !isLeavingRef.current) {
                // We don't want to reconnect too quickly. This gives the subscriptions a chance to
                // fire and to unload the compoent in the case when the disconnect was intentional
                // ex. attendee was removed from room
                logger.debug('Twilio Room disconnect detected.');
                // const timeoutHandle = setTimeout(init, 5000);
                // return () => {
                //   logger.debug('Clearing Timeout')
                //   clearTimeout(timeoutHandle)
                // }
            }
        }
    }, [virtual.joinToken, roomState]);
    useEffect(() => {
        const handleParticipantDisconnected = (e) => {
            const [attendeeId, type] = e.identity.split('.');
            if (attendeeId === virtual.attendeeId && type === 'phone') {
                // Phone audio disconnected connected
                setDialInModalVisible(false);
                setLocalPhoneAudio(false);
            }
            onAttendeeDisconnected && onAttendeeDisconnected(attendeeId, e.identity);
        };
        const handleParticipantConnected = (e) => {
            const [attendeeId, type] = e.identity.split('.');
            if (attendeeId === virtual.attendeeId && type === 'phone') {
                // Phone audio just connected
                setLocalPhoneAudio(true);
                // Turn off local audio
                toggleAudioEnabled(false);
                setDialInModalVisible(false);
            }
        };
        const handleRoomDisconnected = (room) => {
            logger.debug('Twilio  Disconnected Event Fired');
            // When the room is finished
            handleDisconnect(room);
        };
        if (roomState === 'connected') {
            room.on('participantDisconnected', handleParticipantDisconnected);
            room.on('participantConnected', handleParticipantConnected);
            room.on('disconnected', handleRoomDisconnected);
            return () => {
                room
                    .off('participantDisconnected', handleParticipantDisconnected)
                    .off('participantConnected', handleParticipantConnected)
                    .off('disconnected', handleRoomDisconnected);
            };
        }
    }, [roomState, toggleAudioEnabled]);
    const handleDisconnect = (room) => {
        logger.debug('VirtualLayout.handleDisconnect called.');
        try {
            room.localParticipant.videoTracks.forEach(trackPub => {
                logger.debug(`disconnecting video track: ${trackPub.track.id}`);
                trackPub.unpublish();
                trackPub.track.stop();
                const mediaElements = trackPub.track.detach();
                mediaElements.forEach(mediaElement => mediaElement.remove());
            });
            room.localParticipant.audioTracks.forEach(trackPub => {
                logger.debug(`disconnecting audio track: ${trackPub.track.id}`);
                trackPub.track.stop();
                const mediaElements = trackPub.track.detach();
                mediaElements.forEach(mediaElement => mediaElement.remove());
            });
        }
        catch (e) {
            throw new Error(`Error ending the call ${JSON.stringify(e)}`);
        }
        props.onDisconnect();
    };
    // Report call metrics to the service (for recording into NR)
    useInterval(() => __awaiter(this, void 0, void 0, function* () {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34;
        if (roomState === 'connected') {
            const stats = room.localParticipant.networkQualityStats;
            if (stats) {
                const statsData = {
                    video: {
                        send: {
                            bandwidthActual: (_d = (_c = (_b = stats === null || stats === void 0 ? void 0 : stats.video) === null || _b === void 0 ? void 0 : _b.sendStats) === null || _c === void 0 ? void 0 : _c.bandwidth) === null || _d === void 0 ? void 0 : _d.actual,
                            bandwidthAvailable: (_g = (_f = (_e = stats === null || stats === void 0 ? void 0 : stats.video) === null || _e === void 0 ? void 0 : _e.sendStats) === null || _f === void 0 ? void 0 : _f.bandwidth) === null || _g === void 0 ? void 0 : _g.available,
                            fractionLost: (_k = (_j = (_h = stats === null || stats === void 0 ? void 0 : stats.video) === null || _h === void 0 ? void 0 : _h.sendStats) === null || _j === void 0 ? void 0 : _j.fractionLost) === null || _k === void 0 ? void 0 : _k.fractionLost,
                            rtt: (_o = (_m = (_l = stats === null || stats === void 0 ? void 0 : stats.video) === null || _l === void 0 ? void 0 : _l.sendStats) === null || _m === void 0 ? void 0 : _m.latency) === null || _o === void 0 ? void 0 : _o.rtt,
                            jitter: (_r = (_q = (_p = stats === null || stats === void 0 ? void 0 : stats.video) === null || _p === void 0 ? void 0 : _p.sendStats) === null || _q === void 0 ? void 0 : _q.latency) === null || _r === void 0 ? void 0 : _r.jitter,
                            overallQuality: (_s = stats === null || stats === void 0 ? void 0 : stats.video) === null || _s === void 0 ? void 0 : _s.send,
                        },
                        recv: {
                            bandwidthActual: (_v = (_u = (_t = stats === null || stats === void 0 ? void 0 : stats.video) === null || _t === void 0 ? void 0 : _t.recvStats) === null || _u === void 0 ? void 0 : _u.bandwidth) === null || _v === void 0 ? void 0 : _v.actual,
                            bandwidthAvailable: (_y = (_x = (_w = stats === null || stats === void 0 ? void 0 : stats.video) === null || _w === void 0 ? void 0 : _w.recvStats) === null || _x === void 0 ? void 0 : _x.bandwidth) === null || _y === void 0 ? void 0 : _y.available,
                            fractionLost: (_1 = (_0 = (_z = stats === null || stats === void 0 ? void 0 : stats.video) === null || _z === void 0 ? void 0 : _z.recvStats) === null || _0 === void 0 ? void 0 : _0.fractionLost) === null || _1 === void 0 ? void 0 : _1.fractionLost,
                            rtt: (_4 = (_3 = (_2 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _2 === void 0 ? void 0 : _2.recvStats) === null || _3 === void 0 ? void 0 : _3.latency) === null || _4 === void 0 ? void 0 : _4.rtt,
                            overallQuality: (_5 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _5 === void 0 ? void 0 : _5.recv,
                        },
                    },
                };
                if (!localPhoneAudio) {
                    statsData.audio = {
                        send: {
                            bandwidthActual: (_8 = (_7 = (_6 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _6 === void 0 ? void 0 : _6.sendStats) === null || _7 === void 0 ? void 0 : _7.bandwidth) === null || _8 === void 0 ? void 0 : _8.actual,
                            bandwidthAvailable: (_11 = (_10 = (_9 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _9 === void 0 ? void 0 : _9.sendStats) === null || _10 === void 0 ? void 0 : _10.bandwidth) === null || _11 === void 0 ? void 0 : _11.available,
                            fractionLost: (_14 = (_13 = (_12 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _12 === void 0 ? void 0 : _12.sendStats) === null || _13 === void 0 ? void 0 : _13.fractionLost) === null || _14 === void 0 ? void 0 : _14.fractionLost,
                            rtt: (_17 = (_16 = (_15 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _15 === void 0 ? void 0 : _15.sendStats) === null || _16 === void 0 ? void 0 : _16.latency) === null || _17 === void 0 ? void 0 : _17.rtt,
                            jitter: (_20 = (_19 = (_18 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _18 === void 0 ? void 0 : _18.sendStats) === null || _19 === void 0 ? void 0 : _19.latency) === null || _20 === void 0 ? void 0 : _20.jitter,
                            overallQuality: (_21 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _21 === void 0 ? void 0 : _21.send,
                        },
                        recv: {
                            bandwidthActual: (_24 = (_23 = (_22 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _22 === void 0 ? void 0 : _22.recvStats) === null || _23 === void 0 ? void 0 : _23.bandwidth) === null || _24 === void 0 ? void 0 : _24.actual,
                            bandwidthAvailable: (_27 = (_26 = (_25 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _25 === void 0 ? void 0 : _25.recvStats) === null || _26 === void 0 ? void 0 : _26.bandwidth) === null || _27 === void 0 ? void 0 : _27.available,
                            fractionLost: (_30 = (_29 = (_28 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _28 === void 0 ? void 0 : _28.recvStats) === null || _29 === void 0 ? void 0 : _29.fractionLost) === null || _30 === void 0 ? void 0 : _30.fractionLost,
                            rtt: (_33 = (_32 = (_31 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _31 === void 0 ? void 0 : _31.recvStats) === null || _32 === void 0 ? void 0 : _32.latency) === null || _33 === void 0 ? void 0 : _33.rtt,
                            overallQuality: (_34 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _34 === void 0 ? void 0 : _34.recv,
                        },
                    };
                }
                const params = {
                    joinToken: virtual.joinToken,
                    stats: statsData,
                };
                try {
                    yield API.graphql(graphqlOperation(virtualUpdateCallStats, params));
                }
                catch (e) {
                    console.warn(`Unable to update video stats: ${JSON.stringify(e)}`);
                }
            }
        }
    }), 10000);
    const handleEndCall = () => __awaiter(this, void 0, void 0, function* () {
        logger.debug('VirtualLayout.handleEndCall called');
        isLeavingRef.current = true;
        return onLeaving === null || onLeaving === void 0 ? void 0 : onLeaving();
    });
    // We need to inactivate the record button while the container spins up
    const onRecordingChange = useCallback((state) => {
        if (state === RecordingStatus.PREPARING) {
            setDisabledOptions([PresentationMenuOptionsEnum.RECORD]);
        }
        else {
            setDisabledOptions([]);
        }
    }, []);
    const handleTogglePhoneAudio = () => {
        setDialInModalVisible(true);
    };
    const attendeeCount = !currentAttendees ? 0 : Object.values(currentAttendees).filter((p) => (p.status === ATTENDEE_STATUS.ACCEPTED || p.status === ATTENDEE_STATUS.CONNECTED)).length + 1;
    // Set the selected items (blue ones in the top of the screen)
    function selectedMenuItems() {
        const selectedPresentationOptions = [];
        isSharing && selectedPresentationOptions.push(PresentationMenuOptionsEnum.SHARE_SCREEN);
        (displayContentPanel || false) && selectedPresentationOptions.push(PresentationMenuOptionsEnum.MY_CONTENT);
        return selectedPresentationOptions;
    }
    function toggleShareScreen() {
        setInitialState(false);
        roomState === 'connected' && toggleScreenShare();
    }
    return (React.createElement(MeetingControlsContext, { attendeeCount: attendeeCount, audioFiles: audioFiles, disabledOptions: disabledOptions, isFullScreen: isFullScreen, setIsFullScreen: setIsFullScreen, mode: mode, recImage: recImage, hostName: hostName, meetingURL: meetingURL, displayContentPanel: displayContentPanel || false, hideContentPanel: hideContentPanel, isConnected: roomState === 'connected', isHostPresenting: isHostPresenting, isOtherUserScreenSharing: isOtherUserScreenSharing, localPhoneAudio: localPhoneAudio, maxAttendees: MAX_ATTENDEES + 1, onCallEnd: handleEndCall, onRecordingChange: onRecordingChange, onError: onError, onShowContentPanel: showContentPanel, onStopPresenting: onStopPresenting, presentationSelectedOptions: selectedPresentationOptions, shareScreen: toggleShareScreen, toggleHostNotes: toggleHostNotes, togglePhoneAudio: handleTogglePhoneAudio, virtual: virtual },
        React.createElement(DNABox, { fill: true, appearance: "col" },
            React.createElement(DNABox, { fill: true, appearance: "row" },
                React.createElement(DNABox, { fill: true, appearance: "col", style: styles.mainContainer },
                    React.createElement(DialInModal, { isShown: dialInModalVisible, accessCode: virtual.phonePin, dialInNumbers: dialInNumbers, localPhoneAudio: localPhoneAudio, onClose: () => { setDialInModalVisible(!dialInModalVisible); } }),
                    React.createElement(DNABox, { fill: true, childFill: 0, childStyle: [0, { zIndex: -1 }], appearance: "col", spacing: isFullScreen ? 'between' : 'medium' },
                        React.createElement(DNABox, { fill: true, alignX: "center" },
                            React.createElement(DNABox, { fill: true, childFill: 1, spacing: "between", appearance: "col" },
                                React.createElement(VideoContainer, { currentAttendees: currentAttendees, localPhoneAudio: localPhoneAudio, attendeesPerPage: attendeesPerPage, mode: mode, onAcceptCall: onAcceptCall, onAttendeeConnected: onAttendeeConnected, onDenyCall: onDenyCall, isFullScreen: isFullScreen, onRemoveFromCall: onRemoveFromCall, roomState: roomState, participants: ((_a = room.participants) === null || _a === void 0 ? void 0 : _a.size) || 0 }),
                                React.createElement(DNABox, { fill: true, childFill: 1, alignX: "center", spacing: "between", style: styles.contentContainer },
                                    React.createElement(LeftSidePanel, { isFullScreen: isFullScreen, searchPanel: searchPanel, visibleSearch: visibleSearch, setVisibleSearch: setVisibleSearch }, leftSide),
                                    React.createElement(PresentationContainer, { isHostPresenting: isHostPresenting, presentation: presentation, screenShareParticipant: screenShareParticipant, toggleShareScreen: toggleShareScreen, background: background, isInitialState: isInitialState, mode: presentationMode }))))),
                    myContentPanel),
                React.createElement(RightSidePanel, { isFullScreen: isFullScreen }, rightSide)),
            React.createElement(DNABox, { fill: true, appearance: "col", style: [
                    {
                        maxHeight: 75,
                        paddingTop: 3,
                        backgroundColor: colors['color-flat-1200'],
                    },
                    util.mergeStyles(undefined, [styles.fullScreenHeaderWrapper, isFullScreen]),
                ] },
                React.createElement(MeetingControls, null)))));
}
const VirtualLayoutProviders = (props) => (React.createElement(ScreenShareToggleProvider, null,
    React.createElement(AttendeeShareScreenProvider, null,
        React.createElement(Layout, Object.assign({}, props)))));
export default React.memo(withAVChecker(VirtualLayoutProviders));
//# sourceMappingURL=VirtualLayout.js.map